import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InvestmentEditFormFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentEditFormFields";
import { useEditInvestmentForm } from "web_myplann/Portfolio/Forms/InvestmentForm/useEditInvestmentForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditInvestmentFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditInvestmentForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditInvestmentFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } =
		useEditInvestmentForm({
			portfolioId,
			portfolio,
			detailRoute,
		});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<InvestmentEditFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
